import { howItWorks } from "@/mocks/home";

export default function HowItWorks() {
  return (
    <section id="how" className="bg-primary-950 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="mx-auto max-w-6xl">
          <div className="max-w-2xl">
            <p className="flex items-center gap-2 text-xs font-bold tracking-[0.2em] text-accent-400 uppercase mb-3">
              <span className="w-6 h-px bg-accent-400 inline-block" />
              参与方式
            </p>
            <h2 className="font-heading text-2xl md:text-4xl tracking-wide text-background-50">
              三步参与爆料大赛投票评选
            </h2>
            <p className="mt-3 text-sm md:text-base leading-relaxed text-background-200">
              不需要复杂注册，从看到投票只需三步。你的每一票都会被记录进群众打分结果里。
            </p>
          </div>

          <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
            {howItWorks.map((step) => (
              <div key={step.step} className="relative pt-6 border-t-2 border-background-50/20">
                <span className="absolute -top-px left-0 w-16 h-0.5 bg-accent-500" />
                <span className="font-heading text-4xl md:text-5xl text-accent-400">{step.step}</span>
                <h3 className="mt-4 font-heading text-xl tracking-wide text-background-50">{step.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-background-200">{step.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}